/**
 * @copyright Copyright 2019 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare"
], function (declare) {
    /**
     * The "optionsEnabled" property can be set at the Gallery Panel or Gallery Popup level. When true,
     * all Gallery Items will have an 'Options' affordance added. This should only be set during the
     * creation of the Gallery Panel or Gallery Popup and not updated later.
     */

    return declare(null, {

        // Class name used to style elements where "optionsEnabled" is true
        _optionsEnabledClassName: "mwOptionsEnabled",

        // Custom setter for the "optionsEnabled" property
        _setOptionsEnabledAttr: function (isEnabled) {
            if (typeof (isEnabled) !== "boolean") {
                throw new Error("optionsEnabled must be a boolean value.");
            }

            if(isEnabled) {
                // Add the class name when setting this property to "true".
                this.domNode.classList.add(this._optionsEnabledClassName);
            } else {
                // Remove the class name when setting this property to "false".
                this.domNode.classList.remove(this._optionsEnabledClassName);
            }

            this._set("optionsEnabled", isEnabled);
        }
    });
});
